import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Redirige automatiquement vers la page publique de vente
 * selon le sous-domaine de l'URL :
 *  - world-cup.kr-buyer.com/<anything> → /vente/world-cup-2026
 *  - roland-garros.kr-buyer.com/<anything> → /vente/roland-garros
 *  - autres / domaine principal → laisser App principale gérer (login)
 * 
 * IMPORTANT : sur les sous-domaines publics, on FORCE le routing vers
 * la page de vente, sinon les clients pourraient voir l'écran de login
 * de l'admin en tapant /login, /admin, etc.
 */
const PublicRootRedirect = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const host = window.location.hostname.toLowerCase();
    const subdomainToProject = {
      'world-cup': 'world-cup-2026',
      'wc': 'world-cup-2026',
      'roland-garros': 'roland-garros',
      'rg': 'roland-garros',
      'psg': 'psg',
      'ffr': 'ffr',
    };
    const firstSegment = host.split('.')[0];
    const projectSlug = subdomainToProject[firstSegment];
    if (!projectSlug) return;
    // Sur le sous-domaine public : la SEULE route autorisée est /vente/<slug>
    const expectedPath = `/vente/${projectSlug}`;
    if (location.pathname !== expectedPath) {
      navigate(expectedPath, { replace: true });
    }
  }, [navigate, location.pathname]);

  return children;
};

export default PublicRootRedirect;
